import { Button, Container } from 'react-bootstrap';
import {  useQuery, useQueryClient } from 'react-query';
import { getSubscription } from '../../../api/payment';
import { Link, useParams } from 'react-router-dom';
import SpinnerFullScreen from '../../Other/SpinnerFullScreen';

function PaymentSuccess() {
	const {orgId} = useParams();

	const queryClient = useQueryClient();
	const {data: subscription, isLoading, isError, refetch} = useQuery({
		queryKey: ['Subscriptions', orgId],
		queryFn: () => getSubscription(orgId || ""),
		enabled: !!orgId,
		retry: false,
		onSuccess: () => {
			// Invalidate any relevant queries to refresh data
			queryClient.invalidateQueries(['Subscriptions',orgId]);
		}
	});

	return (
		<Container className='mt-5' style={{maxWidth:'800px', position:'relative'}}>
			{isLoading && <SpinnerFullScreen/>}

			{subscription && (
				<div className='text-center  border border-success rounded p-4'>
					<h2>Subscription confirmed!</h2>
					<p>Thank you for working with us!</p>
					<p>Now you can access premium features on our platform.</p>
					<Link to={`/dashboard/orgs/${orgId}`}>
						<Button>Start your service</Button>
					</Link>
				</div>
			)}
			{(isError || !subscription) && (
				<div className='text-center border border-danger rounded p-4'>
					<h2>Failed to confirm subscription.</h2>
					<p>Please try again or <Link to={"/dashboard/support"}>contact us</Link> directly and we can get this sorted out.</p>
					<Button onClick={() => refetch()}>Try again</Button>
				</div>)
			}
		</Container>
	)
};

export default PaymentSuccess;
